/** A From / To day range, with a reset to the last N days.
 *
 * Shared by every date-filtered surface so they cannot drift. Whole local days,
 * not timestamps; consuming routes treat both ends as inclusive.
 */
import { isoDay } from "../utils/attributeFormat";
import styles from "./DateRangePicker.module.css";

export interface DayRange {
  from: string;
  to: string;
}

/** The last `days` days ending today, inclusive of both ends. */
export const lastDays = (days: number): DayRange => {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - (days - 1));
  return { from: isoDay(from), to: isoDay(to) };
};

export const DateRangePicker = ({
  range,
  setRange,
  defaultDays,
}: {
  range: DayRange;
  setRange: (next: DayRange) => void;
  defaultDays: number;
}) => (
  <div className={styles.controls}>
    <label>
      From
      <input
        type="date"
        value={range.from}
        // Each end bounds the other, so the range can never be inverted.
        max={range.to}
        onChange={(e) => setRange({ ...range, from: e.target.value })}
      />
    </label>
    <label>
      To
      <input
        type="date"
        value={range.to}
        min={range.from}
        onChange={(e) => setRange({ ...range, to: e.target.value })}
      />
    </label>
    <button
      type="button"
      className={styles.reset}
      onClick={() => setRange(lastDays(defaultDays))}
    >
      Last {defaultDays} days
    </button>
  </div>
);
